import { Component, Directive, EventEmitter, Input, Output } from '@angular/core';

/**
 * This component is experimental. The purpose of this component is to separate the UI concern from the functionality or features.
 * Its second goal is for open and closed principal by being able to extend the functionality of this component without
 * needing to update this component directly.
 * The idea is this will be used by the model driven filter chips in frontend to have consistent styling.
 * If your filters are simple and the model driven approach works for you then use the frontend library version.
 * If your filters have complicated state or you want to have more control of the level at which the state is stored then this approach
 * allows you to build feature rich filters without having to update the library component.
 * Another bonus is you have full control of loading your filter data and content data which means you don't have to wait for the slowest
 * api but call the content once with default values. You can just show the data and lazily load in the filter data on demand.
 */
@Component({
  selector: 'sales-ui-filter-chip',
  templateUrl: './filter-chip.component.html',
  styleUrls: ['./filter-chip.component.scss'],
  standalone: false,
})
export class FilterChipComponent {
  @Input() canRemove?: boolean;
  @Input() id?: string;

  @Output() clicked = new EventEmitter(); // tslint:disable-line
  @Output() delete = new EventEmitter(); // tslint:disable-line

  emitClickEvent(event: MouseEvent): void {
    event.stopPropagation();
    this.clicked.emit(event);
  }

  emitDeleteEvent(event: MouseEvent): void {
    event.stopPropagation();
    this.delete.emit(event);
  }
}

/* tslint:disable */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'filter-chip-title',
  standalone: false,
})
export class FilterChipTitleDirective {}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'filter-chip-value',
  standalone: false,
})
export class FilterChipValueDirective {}

/* tslint:enable */
